import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { EmptyState } from "@/components/EmptyState";
import { Input } from "@/components/ui/input";
import { Building2 } from "lucide-react";
import { resolveClubLogo } from "@/lib/photoFallback";

export default function ClubsPage() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    const t = setTimeout(() => api.get("/clubs", { params: { q, limit: 60 } }).then((r) => setItems(r.data.items || [])), 250);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="mx-auto w-full max-w-7xl px-3 sm:px-6 lg:px-8 py-6 sm:py-8">
      <h1 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold">Clubs</h1>
      <p className="text-sm text-muted-foreground mt-1">Les clubs sportifs du Fenua.</p>
      <div className="my-4 max-w-md"><Input placeholder="Rechercher un club…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="clubs-search" /></div>
      {items.length === 0 ? <EmptyState icon={Building2} title="Aucun club encore." description="Les clubs créeront leur page institutionnelle ici." /> :
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
          {items.map((c) => (
            <Link key={c.id} to={`/clubs/${c.slug || c.id}`} data-testid="club-card" className="min-w-0">
              <Card className="p-3 sm:p-4 aito-card-hover flex items-center gap-3 h-full">
                <img src={resolveClubLogo(c)} alt={c.name} className="h-12 w-12 sm:h-14 sm:w-14 object-contain shrink-0" />
                <div className="min-w-0 flex-1">
                  <div className="font-display font-semibold text-sm sm:text-base truncate">{c.name}</div>
                  <div className="text-xs text-muted-foreground mt-0.5 truncate">{[c.discipline, c.commune || c.island].filter(Boolean).join(" · ") || "—"}</div>
                  {c.description && <p className="text-xs sm:text-sm mt-1 line-clamp-2">{c.description}</p>}
                </div>
              </Card>
            </Link>
          ))}
        </div>}
    </div>
  );
}
